<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Settings</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active"> Terms and Conditions
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4 class="card-title">Terms and Conditions</h4>
                </div>
                <div class="card-body">
                    <form novalidate @submit.prevent="updateSetting">
                        <validation-errors></validation-errors>

                        <div class="row">
                            <div class="col-12 mb-3">
                                <label class="form-label font-weight-bold">Drivers</label>
                                <vue-editor v-model="setting.driver_terms"></vue-editor>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-12 mb-3">
                                <label class="form-label font-weight-bold">Users</label>
                                <vue-editor v-model="setting.user_terms"></vue-editor>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 mb-3">
                                <label class="form-label font-weight-bold">Fleet Managers</label>
                                <vue-editor v-model="setting.fleet_terms"></vue-editor>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4 col-xs-12">
                                <button class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {VueEditor} from "vue2-editor";
import ValidationErrors from "../../Shared/ValidationErrors";

export default {
    metaInfo: {title: 'Terms and Conditions'},
    name: 'TermsAndConditions',
    props: ['settingsData'],
    components: {
        VueEditor,
        ValidationErrors
    },
    layout: Layout,
    data() {
        return {
            saving: false,
            setting: [],
        }
    },
    methods: {
        async updateSetting() {
            this.saving = true;
            this.$inertia.put(route('admin.settings.update'), {...this.setting}, {
                preserveScroll: true,
                onSuccess: () => this.saving = false,
                onError: () => {
                    this.saving = false;
                }
            });
        }
    },
    mounted() {
        console.log(this.settingsData);
        let data = Object.keys(this.settingsData);
        if (data.length) {
            this.setting.driver_terms = this.settingsData.driver_terms
            this.setting.user_terms = this.settingsData.user_terms
            this.setting.fleet_terms = this.settingsData.fleet_terms
        }
    },
}
</script>
